import React from "react";

const About = () => (
  <section className="container" id="about">
    <h2>About Me</h2>
    <p>
      I’m a passionate Product Manager with experience leading cross-functional teams to deliver impactful digital products.
      I specialize in user research, roadmap planning, and data-driven decision making to create products that solve real problems and drive growth.
    </p>
  </section>
);

export default About;
